/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_All_AppsInputs */

const en_why_listening_compare_all_apps = /** @type {(inputs: Why_Listening_Compare_All_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every device on one subscription`)
};

const es_why_listening_compare_all_apps = /** @type {(inputs: Why_Listening_Compare_All_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos tus dispositivos en una suscripción`)
};

/**
* | output |
* | --- |
* | "Every device on one subscription" |
*
* @param {Why_Listening_Compare_All_AppsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_all_apps = /** @type {((inputs?: Why_Listening_Compare_All_AppsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_All_AppsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_all_apps(inputs)
	return en_why_listening_compare_all_apps(inputs)
});